export default "__VITE_ASSET__DNo2oHam__"